'use strict';

// Alert users where sessionStorage is not available
if (typeof sessionStorage === 'object') {
    try {
        sessionStorage.setItem('sessionStorage', 1);
        sessionStorage.removeItem('sessionStorage');
    } catch (e) {
        Storage.prototype._setItem = Storage.prototype.setItem;
        Storage.prototype.setItem = () => {
        };
        alert('SendRegning krever tilgang til lokal lagring i din nettleser. Skru av privatmodus for å gi tilgang.'); // eslint-disable-line
    }
}

// Legacy browser notification
if (typeof FormData !== 'object' && typeof FormData !== 'function') {
    $('.overlay').hide();
    $('.container').prepend(`
    <a target="_blank" href="//google.com/chrome" style="text-align: center; display: block; width: 100%; padding: 10px 0; background-color: #fff1a8; border-bottom: 1px solid #fcce6e; font-size: 1.1em;">
      Visste du at programmet du bruker for &aring; koble til internett er utdatert? SendRegning vil ikke fungere optimalt med denne versjonen. Klikk her for &aring; laste ned en nyere nettleser!
    </a>
  `);
}

// Moment.js config
moment.locale('no', {
    months: 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
    monthsShort: 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
    weekdays: 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
    weekdaysShort: 'søn_man_tir_ons_tor_fre_lør'.split('_'),
    weekdaysMin: 'sø_ma_ti_on_to_fr_lø'.split('_'),
    relativeTime: {
        future: 'om %s',
        past: 'for %s siden',
        s: 'noen sekunder',
        m: 'ett minutt',
        mm: '%d minutter',
        h: 'én time',
        hh: '%d timer',
        d: 'en dag',
        dd: '%d dager',
        M: 'en måned',
        MM: '%d måneder',
        y: 'ett år',
        yy: '%d år'
    }
});

// App config
function config(cfpLoadingBarProvider, $httpProvider, $compileProvider, $routeProvider, NotificationProvider, vcRecaptchaServiceProvider) {
    cfpLoadingBarProvider.includeSpinner = false;
    $httpProvider.interceptors.push('auth');
    $compileProvider.debugInfoEnabled(false);
    $routeProvider.otherwise('/');

    NotificationProvider.setOptions({
        delay: 9000
    });

    vcRecaptchaServiceProvider.setDefaults({
        key: '6Lew7BATAAAAALlTtdYw6v0F2DBNTyDrFQTRjAox'
    });
}

function bootstrap($rootScope, $window, $location, originatorService, userService) {
    $rootScope.$on('$routeChangeSuccess', (e, current) => {
        const route = current.$$route;

        if (route) {
            $rootScope.noSidebar = route.noSidebar;
            $rootScope.overlay = route.overlay;
            $rootScope.noNav = route.noNav;
            $rootScope.pageTitle = route.title;
            $rootScope.secure = route.secure;
            $rootScope.noNotification = route.noNotification;

            //init originator and user call
            // console.log('--- app');
            if (route.secure) {
              originatorService.getForce();
              userService.getForce();
            }
            // if (!route.noNav || !route.noSidebar) {
            //     if (route.secure) {
            //         // if ($(window).width() > 500) {
            //         // moved to decision-list
            //         //originatorService.getConfirm();
            //         // }
            //     }
            // }
        }

        // update Google Analytics
        // $window.ga('send', 'pageview', {
        //   page: $location.url()
        // });
    });
}

config.$inject = ['cfpLoadingBarProvider', '$httpProvider', '$compileProvider', '$routeProvider', 'NotificationProvider', 'vcRecaptchaServiceProvider'];
bootstrap.$inject = ['$rootScope', '$window', '$location', 'originatorService', 'userService'];

angular
    .module('SendRegning', [
        'ngRoute',
        'ngMessages',
        'angular-loading-bar',
        'vcRecaptcha',
        'sr.alert',
        'sr.chart',
        'sr.dialog',
        'sr.editor',
        'sr.filters',
        'sr.giro',
        'sr.image64',
        'sr.lookups',
        'sr.notification',
        'sr.search',
        'sr.news',
        'sr.theme',
        'sr.store',
        'sr.validators',
        'sr.formatters'
    ])
    .config(config)
    .run(bootstrap);
